import React from "react";
import ReactDOM from "react-dom";
import { Section, Box, Heading, Paragraph, Image, Video, Label } from "grommet";

const RaymarchingPlanet = props => (
  <Section colorIndex={props.colorIndex} pad="medium" align="center">
    {!props.responsive ? (
      <Heading tag="h2" strong={true} margin="small">
        Raymarching Planet Shader
      </Heading>
    ) : null}
    <Box
      direction="column"
      align="center"
      textAlign="left"
      size={{ width: "xxlarge" }}
    >
      <Box size="large">
        <iframe
          width="100%"
          height="300px"
          frameborder="0"
          src="https://www.shadertoy.com/embed/MlBXDz?gui=true&t=10&paused=true&muted=false"
          allowfullscreen
        />
        <Label size="small">Click and drag to rotate planet</Label>
      </Box>
      <Paragraph>
        This is a glsl shader I wrote when I had too much free time and I wanted
        to learn more about ray marching and shadertoy. Every detail of the
        planet is proceduraly generated in the shader program. There is also
        calculations for atmospheric scattering. The clouds are produced from
        these calculations, which gives them the 3D effect.
      </Paragraph>
      <Paragraph>
        I really enjoyed writing this shader over about a week. I had to really
        push myself to a new level to understand the theory behind rendering the
        atmosphere and clouds. I wish I got more opportunities to focus on
        problems like this.
      </Paragraph>
    </Box>
  </Section>
);

export default RaymarchingPlanet;



// WEBPACK FOOTER //
// ./src/components/projects/raymarching-planet/raymarching-planet.js